import {
  ChakraFlex,
  CircularProgress,
  Counter,
  FAIconName,
  FireflyButton,
  Text,
} from '@equip.health/ui';
import { useState } from 'react';
import { useDocumentUpload } from '~/lib/hooks/usePatientDocumentUpload';
import UploadConfirmationModal from '../../common/UploadConfirmationModal';
import { UPLOAD_DOCUMENT } from '~/lib/constants/documentCenter.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { DocumentCenterEvents } from '~/analytics/documentCenterEvents';

interface DocumentsHeaderProps {
  count: number;
  id: string;
  isLoading: boolean;
  patientId: string;
}
const DocumentsHeader = ({
  count,
  id,
  isLoading,
  patientId,
}: DocumentsHeaderProps) => {
  const { trackEvent } = useAnalytics();
  const [isUploadSuccessModalOpen, setIsUploadSuccessModalOpen] =
    useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [fileUploadErrorMessages, setFileUploadErrorMessages] = useState<
    string[]
  >([]);
  const { openFileExplorer } = useDocumentUpload({
    onUploadSuccess: (files, modalErrorMessages) => {
      if (files.length === 0) return;
      setUploadedFiles(files);
      setFileUploadErrorMessages(modalErrorMessages);
      setIsUploadSuccessModalOpen(true);
    },
    patientId,
  });
  return (
    <>
      <ChakraFlex alignItems="center" justifyContent="space-between">
        <ChakraFlex alignItems="center" gap="4px">
          <Text variant="h4">Documents</Text>
          {isLoading ? (
            <CircularProgress
              id={`${id}__loader`}
              isIndeterminate
              size="18px"
            />
          ) : (
            <Counter id={`${id}__counter`} number={count} />
          )}
        </ChakraFlex>

        <FireflyButton
          id={`${id}__upload-document-button`}
          leftIcon={FAIconName.fileArrowUpRegular}
          onClick={() => {
            trackEvent(DocumentCenterEvents.uploadDocumentButtonClicked, {
              Source: AnalyticsSourceValues.DOCUMENT_CENTER,
            });
            openFileExplorer();
          }}
          size="small"
          variant="primary"
        >
          {UPLOAD_DOCUMENT}
        </FireflyButton>
      </ChakraFlex>
      {isUploadSuccessModalOpen && (
        <UploadConfirmationModal
          id={id}
          isOpen={isUploadSuccessModalOpen}
          onClose={() => setIsUploadSuccessModalOpen(false)}
          patientId={patientId}
          uploadedFiles={uploadedFiles}
          uploadErrorMessages={fileUploadErrorMessages}
        />
      )}
    </>
  );
};

export default DocumentsHeader;
